import Vue from 'vue';
import Router from 'vue-router';
import PageNotFound from '@/pages/rent/404';
import Home from '@/pages/rent/Home';
import AccountApp from '@/pages/rent/AccountApp';
import SiteInq from '@/pages/rent/SiteInq';
import SiteRes from '@/pages/rent/SiteRes';
import SiteInt from '@/pages/rent/SiteInt';
import AccountInfo from '@/pages/rent/AccountInfo';

import JoinUs from '@/pages/rent/JoinUs';
import Manage from '@/pages/rent/Manage';

import Forpass from '@/pages/rent/Forpass';
import Chpass from '@/pages/rent/Chpass';
import AnnPage from '@/pages/rent/AnnPage';
import OldPass from '@/pages/rent/OldPass';

import VueBreadcrumbs from 'vue-breadcrumbs';
import { Role } from '@/assets/project_setting/config';

sessionStorage.locale = sessionStorage.locale || 'CH';

Vue.use(Router)
Vue.use(VueBreadcrumbs)

export const router = new Router({
  linkActiveClass: 'active',
  routes: [
    // { path: '*', redirect: '/404' },
    {
      path: '/404',
      name: '404',
      meta: { title: 'Page not found' },
      component: PageNotFound
    },
    {
      path: '/',
      name: 'home',
      meta: { title: '首頁', keepAlive: true, breadcrumb: '首頁' },
      component: Home,
      children: [{
          path: ':newsid/ann_page',
          name: 'ann_page',
          meta: { title: '公告內容', keepAlive: false, breadcrumb: '公告內容' },
          component: AnnPage,
        },
        {
          path: 'account_app',
          name: 'account_app',
          meta: { title: '年度帳號申請', keepAlive: false, breadcrumb: '年度帳號申請' },
          component: AccountApp,
          children: [{
              path: 'join_us',
              name: 'join_us',
              meta: { title: '帳號申請', keepAliveSub: true, breadcrumb: '帳號申請' },
              component: JoinUs
            },
            {
              path: 'manage',
              name: 'manage',
              meta: { title: '帳號管理', keepAliveSub: true, breadcrumb: '帳號管理', role: [Role.USER] },
              component: Manage
            }
          ]
        },
        {
          path: 'site_inq',
          name: 'site_inq',
          meta: { title: '場地查詢申請', keepAlive: false, breadcrumb: '場地查詢申請' },
          component: SiteInq
        },
        {
          path: 'site_res',
          name: 'site_res',
          meta: { title: '場地預約結果', keepAlive: false, breadcrumb: '場地預約結果', role: [Role.USER] },
          component: SiteRes
        },
        {
          path: 'site_int',
          name: 'site_int',
          meta: { title: '場地介紹', keepAlive: false, breadcrumb: '場地介紹' },
          component: SiteInt
        },
        {
          path: 'account_info',
          name: 'account_info',
          meta: { title: '申請帳號說明', keepAlive: false, breadcrumb: '申請帳號說明' },
          component: AccountInfo
        },
        {
          path: 'forpass',
          name: 'forpass',
          meta: { title: '忘記密碼', keepAlive: false, breadcrumb: '忘記密碼' },
          component: Forpass
        },
        {
          path: '/rent/password',
          name: 'chpass',
          meta: { title: '變更密碼', keepAlive: false, breadcrumb: '變更密碼' },
          component: Chpass
        },
        {
          path: 'old_pass',
          name: 'old_pass',
          meta: { title: '網路抽籤申請書', keepAlive: false, breadcrumb: '網路抽籤申請書', role: [Role.USER] },
          component: OldPass
        }
      ]
    }

  ]
});



router.beforeEach((to, from, next) => {
  let checkRole = false;
  if (!to.meta.role) {
    checkRole = true;
  } else if (sessionStorage.Role) {

    let assignRole = JSON.parse(sessionStorage.Role)['RENT'];
    for (let role of assignRole) {
      if (to.meta.role.indexOf(role) !== -1) {
        checkRole = true;
        break;
      }
    }
  }

  if (checkRole) {
    document.title = to.meta.title;
    next();
  } else {
    alert('請先登入');
    next('/account_app');
  }
});



// WEBPACK FOOTER //
// ./src/router/rent/index.js